module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loaded),
      expression: "!loaded"
    }],
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "double-bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "double-bounce2"
  })]), _vm._v(" "), _c('p', [_vm._v("loading...")])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('keep-alive', [_c('router-view', {
    attrs: {
      "name": "user"
    }
  })], 1)], 1), _vm._v(" "), _c('app-bar'), _vm._v(" "), _c('nav-drawer'), _vm._v(" "), _c('div', {
    staticClass: "btn-add",
    class: {
      'active': _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.redirToHome(), _vm.isActive = !_vm.isActive, _vm.sendMsg(_vm.isActive)
      }
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  })]), _vm._v(" "), _c('todo-core'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('keep-alive', [_c('router-view', {
    attrs: {
      "name": "todoView"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('span', [_vm._v("点击红色按钮，开启新的一天")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a696518"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 35
// module chunks = 0